import app from "@/main";
const PAGINATIION_DRAW = 2;
export default {
  SET_TOKEN: (state, payload) => {
    state.token = payload.token;
    state.user.authenticated = true;
  },
  REMOVE_TOKEN: (state, payload) => {
    state.token = "";
    state.user.authenticated = false;
    state.login = {
      id: "",
      username: "",
      firstname: "",
      lastname: "",
      email: "",
      lastlogin: "",
      group_id: "",
      group_name: ""
    };
  },
  SET_USER_DATA: (state, payload) => {
    state.login.id = payload.response.id;
    state.login.username = payload.response.username;
    state.login.firstname = payload.response.firstname;
    state.login.lastname = payload.response.lastname;
    state.login.email = payload.response.email;
    state.login.lastlogin = payload.response.last_login;
    state.login.group_id = payload.response.group_id;
    state.login.group_name = payload.response.group_name;
    state.login.privilege_id = payload.response.privilege_id;
    state.login.privilege_name = payload.response.privilege_name;
    state.login.url_avatar = payload.response.url_avatar;
    state.login.permissions = payload.response.permissions;
  },
  SET_ACTIVATED_PROJECT: (state, payload) => {
    state.activatedProject = payload;
  },
  GET_PROJECT_TEMPLATE_USED: (state, payload) => {
    state.get_project_template_used = payload;
  },
  GET_PROJECT_LIST: (state, payload) => {
    let data = {
      projects: payload.data
    };
    state.projects = data;
  },
  GET_AVAILABLE_MODULE: (state, payload) => {
    const data = payload;
    state.available_module = data;
  },
  GET_TOKEN_UPLOAD: (state, payload) => {
    const data = payload;
    state.token_upload_media = data;
  },
  GET_ADVERTISE_PROJECT_INFO_DETAIL: (state, payload) => {
    const data = payload;
    state.advertiseprojectinfodetail = data;
  },
  GET_PROJECT_MODULE: (state, payload) => {
    const data = payload;
    state.projectmodules = data;
  },
  GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE: (state, payload) => {
    state.apartmentcodefromaccounthomebalance = payload;
  },
  ON_SHOW_TOAST: (state, payload) => {
    const data = payload;
    state.snackbar.push(data);
  },
  DELETE_TOAST: (state, payload) => {
    const data = payload;
    state.snackbar.forEach((v, i, a) => {
      if (data.id === v.id) {
        a.splice(i, 1);
        return true;
      }
    });
  },
  SET_LANG: (state, payload) => {
    app.$i18n.locale = payload;
    state.lang = payload;
  },
  GET_SERVICE_LIST: (state, payload) => {
    let data = payload;
    let result = [];
    data.forEach(value => {
      let service = {
        id: value.id,
        name: value.name,
        dateCreated: value.date_created,
        serviceProviderAddress: value.service_provider_address,
        serviceProviderName: value.service_provider_name,
        feeGroupId: value.feegroup,
        serviceTypeId: value.service_type,
        service_type_details: value.service_type_details,
        servicePrice: value.service_fee,
        serviceCode: value.servicecode,
        serviceCategory: value.category,
        serviceFree: value.free
      };
      result.push(service);
    });
    state.services = result;
    // state.pagination.total = payload.count;
    // state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    // state.pageArrow.prev = payload.previous;
    // state.pageArrow.next = payload.next;
    // setPaginator(state, state.pagination);
  },
  SERVICE_DETAILS: (state, payload) => {
    const data = payload;
    let result = {
      id: data.id,
      name: data.name,
      servicePrice: data.service_fee,
      serviceBusinessHour: data.service_business_hour,
      serviceProviderName: data.service_provider_name,
      serviceProviderAddress: data.service_provider_address,
      feeGroupId: data.feegroup,
      serviceTypeId: data.service_type,
      serviceCode: data.servicecode,
      serviceCategory: data.category,
      serviceFree: data.free,
      serviceVAT: data.vat
    };
    state.serviceDetails = result;
  },
  UPDATE_SERVICE: (state, returnData) => {
    const data = returnData;
    if (data === "undefined") {
      state.serviceReturnData = false;
    } else {
      state.serviceReturnData = true;
    }
  },
  SERVICE_TYPE_LIST: (state, payload) => {
    let data = payload.results;
    let result = [];
    data.forEach(value => {
      let serviceType = {
        id: value.id,
        name: value.name
      };
      result.push(serviceType);
    });
    state.serviceTypes = result;
  },
  GET_SERVICE_HISTORY_LIST: (state, payload) => {
    let data = payload.results;
    let result = [];

    data.forEach(value => {
      let status = "open";
      if (value.status === 2) {
        status = "issued";
      } else if (value.status === 3) {
        status = "paid";
      }
      let service = {
        id: value.id,
        service_name: value.service_name,
        date_from: value.date_from,
        date_to: value.date_to,
        last_month_value: value.last_month_value,
        this_month_value: value.this_month_value,
        total_fees: value.total_fees,
        serviceuser: value.serviceuser,
        invoice: value.invoice_number,
        status: status,
        user_record: value.user_record
      };
      result.push(service);
    });
    state.serviceHistory = result;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    setPaginator(state, state.pagination);
  },
  GET_RECORD_HISTORY_LIST: (state, payload) => {
    let data = payload.response;
    let result = [];

    data.forEach(value => {
      let platform = "CONASI Webadmin";
      if (value.app === 2) {
        platform = "CONASI MobileApp";
      }
      let record_history = {
        id: value.id,
        date_created: value.date_created,
        date_updated: value.date_updated,
        action: value.action,
        platform: platform,
        user_record: value.user_record
      };
      result.push(record_history);
    });
    state.serviceRecordHistory = result;
  },
  GET_CUSTOMER_DETAIL: (state, payload) => {
    state.customerDetails = payload;
  },
  GET_INVOICE_CUSTOMER_LIST: (state, payload) => {
    state.invoiceCustomer = payload;
  },
  GET_CUSTOMER_LIST: (state, payload) => {
    let customer_data = payload.results;
    let customer_list = [];

    customer_data.forEach(value => {
      let apartment_code =
        value.apartments != undefined && value.apartments != null
          ? value.apartments.length == 0
            ? ""
            : value.apartments.map(e => e.apartment_code).join(", ")
          : "";
      let customer_info = {
        id: value.id,
        username: value.username,
        firstname: value.first_name,
        lastname: value.last_name,
        lastlogin: value.lastlogin,
        email: value.email,
        groups: value.groups,
        privilege: value.privilege,
        apartment: value.apartments,
        apartment_code: apartment_code
      };

      if (value.profile != null) {
        (customer_info.age = value.profile.age),
          (customer_info.phone = value.profile.phone),
          (customer_info.gender = value.profile.gender),
          (customer_info.crmcode = value.profile.customer_crm_code),
          (customer_info.country_name = value.profile.country_name),
          (customer_info.company_name = value.profile.company_name),
          (customer_info.company_address = value.profile.company_address),
          (customer_info.company_tax_code = value.profile.company_tax_code),
          (customer_info.personal_tax_code = value.profile.personal_tax_code),
          (customer_info.is_company = value.profile.is_company),
          (customer_info.code = value.profile.code),
          (customer_info.profile = value.profile);
      }
      customer_list.push(customer_info);
    });
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.customers = customer_list;

    setPaginator(state, state.pagination);
  },
  GET_UPLOAD_USER_DATA: (state, payload) => {
    state.file_upload_user_data = payload.data;
  },
  GET_CUSTOMER_LIST_REWARD_POINT: (state, payload) => {
    let data = payload;
    let data_customer_give_point = [];
    data.forEach(el => {
      let list = {
        email: el.email,
        first_name: el.first_name,
        last_name: el.last_name,
        id: el.id,
        reward_point: el.profile.reward_point
      };
      data_customer_give_point.push(list);
    });
    state.customer_give_reward_point = data_customer_give_point;
  },
  GET_ASSIGN_SERVICE_DATA: (state, payload) => {
    let service_data = payload;
    let assigned_service_list = [];

    service_data.forEach(value => {
      let service_info = {
        id: value.id,
        service_id: value.service,
        date_from: value.date_from,
        date_to: value.date_to,
        service_name: value.service_name
      };
      assigned_service_list.push(service_info);
    });
    state.serviceAssigned = assigned_service_list;
  },
  GET_USER_DETAIL: (state, payload) => {
    state.userDetails = payload;
  },
  GET_LEASEBACK_COMPANY_LIST: (state, payload) => {
    state.leaseback_company_list = payload;
  },
  GET_USER_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let user_data = payload.results;
      let user_list = [];

      user_data.forEach(value => {
        let user_info = {
          id: value.id,
          username: value.username,
          firstname: value.first_name,
          lastname: value.last_name,
          lastlogin: value.lastlogin,
          email: value.email,
          age: value.profile.age,
          phone: value.profile.phone,
          gender: value.profile.gender,
          country_code: value.profile.country_code,
          groups: value.groups,
          privilege: value.privilege,
          code: value.profile.code,
          is_active: value.profile.is_active,
          is_blocked: value.profile.is_blocked
        };
        user_list.push(user_info);
      });
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      state.users = user_list;
    } else {
      state.users = payload;
    }

    setPaginator(state, state.pagination);
  },
  GET_STAFF_LIST: (state, payload) => {
    state.staffs = payload;
  },
  GET_CARDS_LIST: (state, payload) => {
    state.cards = payload;
  },
  GET_RELATIVE_LIST: (state, payload) => {
    state.relatives = payload;
  },
  GET_RELATIVE_DETAIL: (state, payload) => {
    state.relativeDetails = payload;
  },
  GET_APARTMENT_LIST: (state, payload) => {
    let apartments = payload["page"] != null ? payload.results : payload;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.apartments = apartments;
    setPaginator(state, state.pagination);
  },
  GET_APARTMENT_LIST_NO_PAGE: (state, payload) => {
    state.apartmentListNoPage = payload;
  },
  GET_APARTMENT_REALESTATE_LIST: (state, payload) => {
    let apartmentrealestate =
      payload["page"] != null ? payload.results : payload;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.apartmentrealestate = apartmentrealestate;
    setPaginator(state, state.pagination);
  },
  GET_APARTMENT_SCHEDULE_PROGRESS_LIST: (state, payload) => {
    let apartmentscheduleprogress =
      payload["page"] != null ? payload.results : payload;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.apartmentscheduleprogress = apartmentscheduleprogress;
    setPaginator(state, state.pagination);
  },
  GET_LIST_EMAIL_HISTORY_AGENT: (state, payload) => {
    let emailHistoruAgentListResult =
      payload["page"] != null ? payload.results : payload;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    setPaginator(state, state.pagination);
    state.emailHistoruAgentListResult = emailHistoruAgentListResult;
  },
  GET_REWARD_POINT: (state, payload) => {
    state.reward_points = payload;
  },
  GET_AVAILABLE_APARTMENT_LIST: (state, payload) => {
    //let available_apartments = payload.results;
    let available_apartments = payload;
    state.available_apartments = available_apartments;
    /*state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.available_apartments = available_apartments;
    setPaginator(state, state.pagination);*/
  },
  GET_APARTMENT_USAGE_LIST: (state, payload) => {
    let reportusage = payload.results;
    state.reportusage = reportusage;
  },
  GET_APARTMENT_REALESTATE_DETAIL: (state, payload) => {
    state.apartmentRealestateDetails = payload;
  },
  GET_CONTRACT_DETAIL: (state, payload) => {
    state.contract_detail = payload.data;
  },
  GET_CONTRACT_LIST: (state, payload) => {
    let contractlist = payload["page"] != null ? payload.results : payload;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.contract_data = contractlist;
    setPaginator(state, state.pagination);
  },
  PAYMENT_PROGRESS_LIST: (state, payload) => {
    state.payment_progress = payload.data;
  },
  GET_UPLOAD_CONTRACT_DATA: (state, payload) => {
    state.file_upload_contract_data = payload.data;
  },
  GET_UPLOAD_CASE_DATA: (state, payload) => {
    state.file_upload_case_data = payload.data;
  },
  GET_PAYMENT_PROGRESS_DETAIL: (state, payload) => {
    state.payment_progress_detail = payload;
  },
  DELETE_CONTRACT: (state, payload) => {
    // state.deleteContract = payload;
  },
  GET_APARTMENT_SCHEDULE_PROGRESS_DETAIL: (state, payload) => {
    state.apartmentScheduleProgressDetails = payload;
  },
  DELETE_APARTMENT_REALESTATE_LIST: (state, payload) => {
    state.deleteApartmentScheduleProgressResult = payload;
  },
  GET_ADVERTISE_DATA: (state, payload) => {
    let ad = payload.results;
    state.advertise = ad;
  },
  GET_ADVERTISE_DATA_PROJECT_INFO: (state, payload) => {
    let ad_pro_inf = payload;
    state.advertiseProjectInfo = ad_pro_inf;
  },
  // User Guest
  GET_USER_GUEST_LIST: (state, payload) => {
    let user_data = payload.results;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.userguest = user_data;
    setPaginator(state, state.pagination);
  },
  GET_USER_GUEST_DETAIL: (state, payload) => {
    state.userguestdetail = payload;
  },
  GET_ADVERTISE_DETAIL: (state, payload) => {
    state.advertisedetail = payload;
  },
  GET_APARTMENT_DETAIL: (state, payload) => {
    state.apartmentDetails = payload;
  },
  GET_VEHICLE_TYPE_LIST: (state, payload) => {
    let vehicle_types = payload;
    state.vehicle_types = vehicle_types;
  },
  GET_FLOOR_APARTMENT: (state, payload) => {
    state.floor_apartment = payload;
  },
  GET_VEHICLE_MANUFACTURER_LIST: (state, payload) => {
    state.vehicle_manufacturers = payload;
  },
  GET_VEHICLE_LIST: (state, payload) => {
    state.vehicles = payload;
    setPaginator(state, state.pagination);
  },
  GET_VEHICLE_DETAIL: (state, payload) => {
    state.vehicleDetails = payload;
  },
  GET_CASE_LIST: (state, payload) => {
    let cases = payload.results;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.cases = cases;
    setPaginator(state, state.pagination);
  },
  GET_CASE_DETAIL: (state, payload) => {
    state.caseDetails = payload;
  },
  GET_TODO_LIST: (state, payload) => {
    let todo = payload.response;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.todoList = todo;
    setPaginator(state, state.pagination);
  },
  GET_ESCALATION_PROCESS_LIST: (state, payload) => {
    state.escalationProcesses = payload;
  },
  GET_ESCALATION_STAGE_LIST: (state, payload) => {
    state.escalationStages = payload;
  },
  GET_PROPERTY_LIST: (state, payload) => {
    let property_data = payload.results;
    let property_list = [];

    property_data.forEach(value => {
      let property_info = {
        id: value.id,
        name: value.name,
        type_name: value.type_name,
        price: value.price,
        price_depreciation: value.price_depreciation,
        date_created: value.date_created,
        code: value.code,
        amount: value.amount
      };
      property_list.push(property_info);
    });
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.propertys = property_list;
    setPaginator(state, state.pagination);
  },
  UPDATE_PROPERTY: (state, returnData) => {},
  GET_PROPERTY_DETAIL: (state, payload) => {
    state.propertyDetails = payload;
  },
  ADD_PROPERTY: (state, payload) => {
    //
  },
  GET_PROPERTY_TYPE_LIST: (state, payload) => {
    let data = payload.results;
    let result = [];
    data.forEach(value => {
      let propertyType = {
        id: value.id,
        name: value.name
      };
      result.push(propertyType);
    });
    state.propertyTypes = result;
  },
  DELETE_PROPERTY: (state, payload) => {
    //
  },
  DELETE_RESIDENT: (state, payload) => {
    //
  },
  GET_RESIDENT_LIST: (state, payload) => {
    let resident_data = payload;
    let resident_list = [];

    resident_data.forEach(value => {
      let resident_info = {
        id: value.id,
        isMainContact: value.isMainContact,
        isOwner: value.isOwner,
        isTenant: value.isTenant,
        resident_movein: value.resident_movein,
        resident_moveout: value.resident_moveout,
        start_efigure: value.start_efigure,
        start_wfigure: value.start_wfigure,
        resident_status: value.resident_status,
        relationship: value.relationship,
        relationship_note: value.relationship_note,
        apartment: value.apartment,
        resident: value.resident,
        relationship_to: value.relationship_to
      };
      resident_list.push(resident_info);
    });
    state.residents = resident_list;
  },
  GET_RESIDENT_DETAIL: (state, payload) => {
    state.residentDetails = payload;
  },
  // =======================================
  // BEGIN - TABLE INVOICE_STATUS
  // =======================================
  GET_INVOICE_LIST: (state, payload) => {
    // let invoice_data = payload.results
    let invoice_list = payload.results;

    // invoice_data.forEach(value => {
    //   let invoice_info = value
    // let invoice_info = {
    //   'id': value.id,
    //   'invoice_number':value.invoice_number,
    //   'invoice_user': value.invoice_user,
    //   'user_name': value.user_name,
    //   'invoice_status':value.invoice_status,
    //   'status_name':value.status_name,
    //   'date_issued':value.date_issued,
    //   'date_paid':value.date_paid,
    //   'total_fees':value.total_fees,
    //   'other_details':value.other_details
    // }
    //   invoice_list.push(invoice_info)
    // })

    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.invoices = invoice_list;
    setPaginator(state, state.pagination);
  },
  GET_INVOICE_LIST_PERFORMANCE_VS2: (state, payload) => {
    // let invoice_data = payload.results
    let invoices_list_performance = payload.results;

    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.invoices_list_performance_vs2 = invoices_list_performance;
    setPaginator(state, state.pagination);
  },

  GET_INVOICE_RECEIPT_LIST_PERFORMANCE: (state, payload) => {
    // let invoice_data = payload.results
    let invoices_receipt_list_performance = payload.results;
    state.invoices_receipt_list_performance = invoices_receipt_list_performance;
  },

  GET_FILTER_INVOICE_LIST: (state, payload) => {
    // let invoice_data = payload.results
    let invoice_list = payload;
    state.filterInvoices = invoice_list;
  },
  GET_INVOICE_DETAIL: (state, payload) => {
    state.invoiceDetails = payload;
  },
  ADD_INVOICE: (state, payload) => {
    //
  },
  UPDATE_INVOICE: (state, returnData) => {
    const data = returnData;
    if (data === "undefined") {
      state.invoiceReturnData = false;
    } else {
      state.invoiceReturnData = true;
    }
  },
  DELETE_INVOICE: (state, payload) => {
    //
  },
  // =======================================
  // END - TABLE INVOICE
  // =======================================
  GET_MOBILE_NOTIFICATION: (state, payload) => {
    state.mobile_notification = payload;
  },

  // =======================================
  // BEGIN - TABLE INVOICE_STATUS
  // =======================================
  GET_INVOICE_STATUS_LIST: (state, payload) => {
    // let invoice_data = payload.results
    let invoice_status_list = payload.results;

    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.invoiceStatus = invoice_status_list;
    setPaginator(state, state.pagination);
  },
  GET_INVOICE_STATUS_DETAIL: (state, payload) => {
    state.invoiceStatusDetails = payload;
  },
  ADD_INVOICE_STATUS: (state, payload) => {
    //
  },
  UPDATE_INVOICE_STATUS: (state, returnData) => {
    const data = returnData;
    if (data === "undefined") {
      state.invoiceStatusReturnData = false;
    } else {
      state.invoiceStatusReturnData = true;
    }
  },
  DELETE_INVOICE_STATUS: (state, payload) => {
    //
  },
  GET_CURRENT_USAGE: (state, payload) => {
    state.period_current = payload.message;
  },
  // =======================================
  // END - TABLE INVOICE_STATUS
  // =======================================

  GET_APARTMENT_MONTHLY_USAGE: (state, payload) => {
    let data = payload.results;
    let result = [];

    data.forEach(value => {
      let status = "open";
      if (value.status === 2) {
        status = "issued";
      } else if (value.status === 3) {
        status = "paid";
      }
      let apartment_monthly = {
        id: value.id,
        service_name: value.service.name,
        service_code: value.service.servicecode,
        service_id: value.service.id,
        date_from: value.date_from,
        date_to: value.date_to,
        note: value.note,
        last_month_value: value.last_month_value,
        this_month_value: value.this_month_value,
        total_fees: value.total_fees,
        apartment: value.apartment,
        invoice_number: value.invoice_number,
        status: status,
        //user_record: value.user.username,
        full_name: value.user.lastname + " " + value.user.firstname,
        phone: value.user.phone,
        email: value.user.email,
        user: value.user.id,
        date_created: value.date_created,
        price_unit: value.price_unit,
        vat: value.vat
      };
      result.push(apartment_monthly);
    });
    state.apartmentMonthlyUsage = result;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    setPaginator(state, state.pagination);
  },
  ADD_APARTMENT_MONTHLY_USAGE: (state, payload) => {
    //
  },
  GET_TEMPLATE_DATA: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.get_template_email_data = {results: payload.results, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.get_template_email_data = payload.results;
    }
  },
  GET_TEMPLATE_DETAIL: (state, payload) => {
    state.templateEmailDetailData = payload;
  },
  GET_EMAIL_TEMPLATE_CATEGORY: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.emailTemplateCategory = {results: payload.results, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.emailTemplateCategory = payload.results;
    }
  },
  GET_APARTMENT_MONTHLY_USAGE_LIST: (state, payload) => {
    state.apartmentMonthlyUsage = payload.results;
  },
  IMPORT_APARTMENT: (state, payload) => {
    //
  },
  GET_TEMPLATE_EMAIL_OBJECT: (state, payload) => {
    state.templateemailobject = payload;
  },
  //Asset
  GET_ASSET_LIST: (state, payload) => {
    let asset_data = payload.page == null ? payload : payload.results;
    let asset_list = [];

    asset_data.forEach(value => {
      let asset_info = {
        name: value.name,
        type: value.type,
        asset_sub_type: value.asset_sub_type,
        asset_status: value.asset_status,
        asset_status_name: value.asset_status_data.name,
        type_name: value.type_name,
        location: value.location,
        installed_date: value.installed_date,
        provider: value.provider,
        provider_address: value.provider_address,
        provider_phone: value.provider_phone,
        provider_email: value.provider_email,
        maintaince_type: value.maintaince_type,
        maintainance_sub_type: value.maintainance_sub_type,
        maintainance_start_date: value.maintainance_start_date,
        maintainance_expired_date: value.maintainance_expired_date,
        maintainance_required_date: value.maintainance_required_date,
        maintainance_repeat_option: value.maintainance_repeat_option,

        // [loitt] - add ticket #866
        price: value.price,
        total: value.total,
        unit: value.unit,
        other_details: value.other_details,
        quantity: value.quantity,
        code: value.code,
        id: value.id,
        apartment: value.apartment,
        contacter: value.fullname,
        next_maintainance_date: value.next_maintainance_date
      };
      asset_list.push(asset_info);
    });
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.assets = asset_list;
    setPaginator(state, state.pagination);
  },
  GET_ASSET_LIST_V2: (state, payload) => {
    let assetV2List = payload.results !== undefined ? payload.results : payload;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.assetV2List = assetV2List;

    let page = {
      totalItem: payload.count,
      currentPage: isNaN(payload.page) ? 1 : payload.page,
      pageSize: payload.page_size,
      numPages: payload.num_pages
    }
    state.assetV2List = {results: assetV2List, paginate: page};

    setPaginator(state, state.pagination);
  },
  GET_ASSET_LIST_V2_NO_PAGE: (state, payload) => {
    let assetV2ListNoPage = payload;
    state.assetV2ListNoPage = assetV2ListNoPage;
  },
  UPDATE_ASSET: (state, returnData) => {},
  GET_ASSET_DETAIL: (state, payload) => {
    state.assetDetails = payload;
  },
  ADD_ASSET: (state, payload) => {
    //
  },
  DELETE_ASSET: (state, payload) => {
    //
  },
  GET_ASSET_TYPE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let assetTypes = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.assetTypes = {results: assetTypes, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.assetTypes = payload;
    }
  },
  ADD_ASSET_TYPE: (state, payload) => {
    //
  },
  ADD_CASE_TYPE: (state, payload) => {
    //
  },
  ADD_CASE_SUB_TYPE: (state, payload) => {
    //
  },
  ADD_ASSET_SUB_TYPE: (state, payload) => {
    //
  },
  UPLOAD_IMAGE: (state, payload) => {
    //
  },
  UPLOAD_FILE: (state, payload) => {
    //
  },
  GET_REPORT_MONTHLY_USAGE_LIST: (state, payload) => {
    let reportmonthlyusage = payload;
    state.reportmonthlyusage = reportmonthlyusage;
  },
  GET_SERVICE_MONTHLY_USAGE_LIST: (state, payload) => {
    let data = payload;
    state.apartmentservicemonthlyusage = data;
  },
  GET_BULK_DATA_IMPORT: (state, payload) => {
    let data = payload;
    state.get_bulk_data_import = data;
  },
  CONFIRM_IMPORT_BULK: (state, payload) => {
    ////
  },
  GET_INVOICE_LIST_BY_SEARCH_TEMPLATE: (state, payload) => {
    state.invoiceListByTemplate = payload;
  },
  CHANGE_ISSUED_TO_PAID: (state, payload) => {},
  SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG: (state, payload) => {},
  GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG: (state, payload) => {
    state.customizetablepersonalconfig = payload;
  },
  SET_MEMBERROLECODE: (state, payload) => {
    state.memberrolecodes = payload.data;
  },
  SET_CURRENT_ROLE: (state, payload) => {
    state.current_role = payload;
  },
  SET_ALLMODULES: (state, payload) => {
    state.projectallmodules = payload.data;
  },
  GET_ALL_MODULES_PROJECT: (state, payload) => {
    state.projectallmodules_new_project = payload.data;
  },
  SET_ROLEPERMISSION: (state, payload) => {
    state.rolepermission = payload;
  },
  SET_FUNCTIONS: (state, payload) => {
    state.functions = payload;
  },
  SET_FUNCTIONPERMISSIONS: (state, payload) => {
    state.functionpermissions = payload;
  },
  SET_APARTMENTPERMISSIONS: (state, payload) => {
    let permission_groups = payload.permission_groups;
    state.apartment_permissions = permission_groups;
  },
  COUNT_LIABILITIES_APARTMENT_MONTHLY_USAGE: (state, payload) => {
    state.apartment_monthly_usage_liabilities = payload;
  },
  GET_PROJECT_HISTORY_LIST: (state, payload) => {
    let project_history_list = payload.results;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.project_history_list = project_history_list;
    let page = {
      totalItem: payload.count,
      currentPage: isNaN(payload.page) ? 1 : payload.page,
      pageSize: payload.page_size,
      numPages: payload.num_pages
    }
    state.project_history_list = {results: project_history_list, paginate: page};
    setPaginator(state, state.pagination);
  },
  GET_PROJECT_BANK_TRANSFER: (state, payload) => {
    state.project_bank_transfer = payload;
  },
  GET_SEARCH_LIST: (state, payload) => {
    let search_list = payload;
    // state.pagination.total = payload.count;
    // state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    // state.pageArrow.prev = payload.previous;
    // state.pageArrow.next = payload.next;
    state.search_list = search_list;
    setPaginator(state, state.pagination);
  },
  GET_PROJECT_ALL_ALL_MODULE: (state, payload) => {
    state.project_all_all_module = payload;
  },
  GET_RECEIPT_LIST: (state, payload) => {
    let receipts = payload.results;

    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.receipts = receipts;
    setPaginator(state, state.pagination);
  },
  GET_BATCH_JOB_LIST: (state, payload) => {
    let batch_jobs = payload.results;

    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.batch_jobs = batch_jobs;
    setPaginator(state, state.pagination);
  },
  GET_BATCH_JOB_HISTORY: (state, payload) => {
    let batch_jobs_history = payload.results;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.batch_jobs_history = batch_jobs_history;
    setPaginator(state, state.pagination);
  },
  GET_RECEIPT_DETAIL: (state, payload) => {
    state.receiptDetails = payload;
  },
  SET_BATCH_JOB_DETAIL: (state, payload) => {
    state.batchJobDetails = payload;
  },
  ADD_RECEIPT: (state, payload) => {
    //
  },
  GET_LIST_AVAILABLE_BANKS: (state, payload) => {
    state.available_banks = payload;
  },

  // =========================================================
  // MOBILE APPLICATION, OPERATION SYSTEM AND OS VERSION
  // =========================================================

  GET_MOBILE_APPLICATION_LIST: (state, payload) => {
    state.mobileApplications = payload;
  },

  GET_MOBILE_OS_LIST: (state, payload) => {
    state.mobileOperationSystems = payload;
  },

  GET_MOBILE_OS_VERSION_LIST: (state, payload) => {
    state.mobileOSVersion = payload;
  },
  GET_REPAIR_LIST: (state, payload) => {
    state.repairList = payload;
  },
  GET_RECEIPT_LIST_BY_ID: (state, payload) => {},
  GET_STATISTICAL_EXPORT_INVOICE: (state, payload) => {
    state.statisticalExportInvoice = payload;
  },
  GET_STATISTICAL_APARTMENT_PAYMENT_LATE: (state, payload) => {
    state.statisticalApartmentPaymentLate = payload;
  },
  CHANGE_RESIDENT_TO_SERVICE_APARTMENT: (state, payload) => {},
  GET_COUPONS_LIST: (state, payload) => {
    state.coupons = payload;
    let coupons = payload.results;

    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.coupons = coupons;
    setPaginator(state, state.pagination);
  },
  GET_COUPON_DETAIL: (state, payload) => {
    state.couponDetails = payload;
  },
  GET_CODE_COUPON: (state, payload) => {
    state.couponCode = payload;
  },
  setPaginator: (state, pages) => {
    setPaginator(state, pages);
  },
  GET_APARTMENT_RESERVATION_LIST: (state, payload) => {
    state.apartmentReservations = payload;
    state.statisticalApartmentPaymentLate = payload;
  },
  SEND_INVOICE_INFORMATION_TO_USER: (state, payload) => {
    state.sendInvoiceInformationToUser = payload;
  },
  DELETE_INVOICE_LIST: (state, payload) => {
    state.deleteInvoiceListResult = payload;
  },
  // DELETE_APARTMENT_SCHEDULE_PROGRESS_LIST: (state, payload) => {
  // DELETE_APARTMENT_REALESTATE_LIST: (state, payload) => {
  //   state.deleteApartmentRealestateListResult = payload;
  // },
  GET_BOOKING_DETAIL: (state, payload) => {
    state.bookingDetails = payload.data;
  },
  GET_BOOKING_DETAIL_BY_BOOKING_CODE: (state, payload) => {
    state.bookingDetailsByBookingCode = payload.data;
  },
  GET_ALL_BOOKING_BY_APARTMENT: (state, payload) => {
    state.allBookingByApartment = payload.data;
  },
  GET_APARTMENT_CUSTOMER_INFORMATION_BOOKING_DETAIL: (state, payload) => {
    state.apartmentCustomerInfoBookingDetail = payload.data;
  },
  GET_INVOICE_BOOKING_PAYMENT_DETAIL: (state, payload) => {
    state.invoice_booking_payment_detail = payload.data;
  },
  GET_BOOKINGS_BY_APARTMENT_BEFORE_MOVING: (state, payload) => {
    state.bookingsByApartmentBeforeMoving = payload.data;
  },
  GET_DOCUMENT_LIST: (state, payload) => {
    state.documents = payload;
  },
  GET_DOCUMENT_DETAIL: (state, payload) => {
    state.documents = payload;
  },
  GET_LAST_THIS_W_E_MONTH_VALUE: (state, payload) => {
    state.lastThisWEMonthValue = payload;
  },
  GET_APARTMENT_LEASEBACK_CLIENTS_LIST: (state, payload) => {
    let apartment_leaseback_clients = payload;
    state.apartment_leaseback_clients = apartment_leaseback_clients;
  },
  DETAILED_REPORT_BY_EACH_MONTH: (state, payload) => {
    state.detailedReportByEachMonth = payload;
  },
  GET_DETAILED_REPORT_A_MONTH: (state, payload) => {
    state.detailedReportAMonth = payload;
  },
  GET_EINVOICE_BKAV_LIST: (state, payload) => {
    let einvoices = payload.results;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.einvoices = einvoices;
    setPaginator(state, state.pagination);
  },
  GET_BOOKING_PAYMENT_LIST: (state, payload) => {
    let bookingPayments = payload.results;

    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.bookingPayments = bookingPayments;
    setPaginator(state, state.pagination);
  },

  GET_INVOICE_GENERAL_INVOICE_LIST: (state, payload) => {
    let invoice_general_invoice_list =
      payload["page"] != null ? payload.results : payload;
    state.pagination.total = payload.count;
    state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
    state.pageArrow.prev = payload.previous;
    state.pageArrow.next = payload.next;
    state.invoice_general_invoice_list = invoice_general_invoice_list;
    setPaginator(state, state.pagination);
  },
  GET_INVOICE_GENERAL_INVOICE_DETAIL: (state, payload) => {
    state.invoice_general_invoice_detail = payload;
  },
  GET_PROJECT_TEMPLATE: (state, payload) => {
    state.projectemailtemplate = payload;
  },
  // [#1059] - loitt
  DELETE_SERVICE: (state, payload) => {
    //
  },
  DELETE_FORM_EMAIL: (state, payload) => {
    //
  },
  GET_GROUP_BOOKING_DETAIL: (state, payload) => {
    state.groupBookingDetails = payload.data;
  },
  STATISTICS_HAS_BREAKFAST_RESIDENT_CLIENTS: (state, payload) => {
    state.statisticsHasBreakFastResidentClients = payload.data;
  },
  GET_APARTMENT_CLEANING_SERVICE: (state, payload) => {
    let cleaningService = payload;
    state.cleaningService = cleaningService;
  },
  GET_APARTMENT_CLEANING_SERVICE_START_END_TIME: (state, payload) => {
    let cleaningServiceStartEnd = payload;
    state.cleaningServiceStartEnd = cleaningServiceStartEnd;
  },
  // server setting
  GET_SYSTEM_SMTP_CONFIG: (state, payload) => {
    state.get_smtp_config = payload;
  },
  GET_SMTP_PROJECT: (state, payload) => {
    state.get_smtp_project = payload;
  },
  GET_CONFIG_SMTP_EMAIL_SERVER: (state, payload) => {
    state.get_config_smtp_email_server = payload;
  },
  PUSH_CONFIG_SMTP_EMAIL_SERVER: (state, payload) => {
    state.get_config_smtp_email_server = payload;
  },
  //media
  GET_MEDIA_CONFIG: (state, payload) => {
    state.get_media_config = payload;
  },
  GET_MEDIA_PROJECT: (state, payload) => {
    state.get_media_project = payload;
  },
  GET_SMTP_COMPANY_CONFIG: (state, payload) => {
    let smtpConfigList = payload;
    state.smtpProjectConfigList = smtpConfigList
  },
  GET_USE_CUSTOM_SMTP_CONFIG: (state, payload) => {
    let useCustomSMTPConfig = payload;
    state.useCustomSMTPConfig = useCustomSMTPConfig
  },
  GET_CONFIG_SMTP_PROJECT_EMAIL_SERVER: (state, payload) => {
    let smtpProjectConfigEmailList = payload;
    state.smtpProjectConfigEmailList = smtpProjectConfigEmailList
  },
  GET_SMTP_PROJECT_LIST: (state, payload) => {
    let smtpConfigList = payload;
    state.smtpProjectList = smtpConfigList
  },
  GET_BANNER_LIST_HANDLER: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let bannerData = payload.results;
      let bannerList = [];
      bannerData.forEach(value => {
        let bannerInfo = {
          id: value.id,
          imageUrl: value.image_url,
          title: value.title,
          status: value.status,
          position: value.position,
          dateCreated: value.date_created
        };
        bannerList.push(bannerInfo);
      });
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      state.bannerList = bannerList;
    } else {
      state.bannerList = payload;
    }

    setPaginator(state, state.pagination);
  },
  // =======================================
  // CONFIG NOTIFICATION CATEGORY
  // =======================================
  GET_CATEGORY_NOTIFICATION_HANDLE: (state, payload) => {
    // let notificationCategory = payload;
    // state.notificationCategory = notificationCategory
    let product = payload.results !== undefined ? payload.results : payload
    if (payload.results !== undefined) {
      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.notificationCategory = { results: product, paginate: page }
    } else {
      state.notificationCategory = payload
    }
  },
  GET_RESIDENTS_NEWS_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let bannerData = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      state.newsResidentsList = bannerData;
    } else {
      state.newsResidentsList = payload;
    }

    setPaginator(state, state.pagination);
  },
  GET_NEWS_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let newsData = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      // state.newsList = newsData;
      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.newsList = {results: newsData, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.newsList = payload;
    }
  },
  GET_NEWS_CATEGORY_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let newsCategoriesList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      // state.newsCategoriesList = newsCategoriesList;
      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.newsCategoriesList = {results: newsCategoriesList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.newsCategoriesList = payload;
    }
  },
  // =======================================
  // Register export invoice
  // =======================================
  GET_REGISTER_EXPORT_INVOICE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let registerExportData = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      state.registerExportInvoiceList = registerExportData;
      setPaginator(state, state.pagination);
    } else {
      state.registerExportInvoiceList = payload;
    }
  },
  GET_REGISTER_EXPORT_INVOICE_LIST_NO_PAGE: (state, payload) => {
    let registerExportInvoiceListNoPage = payload;
    state.registerExportInvoiceListNoPage = registerExportInvoiceListNoPage
  },
  // =======================================
  // Feedback
  // =======================================
  GET_FEEDBACK_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let feedbackList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.feedbackList = {results: feedbackList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.feedbackList = payload;
    }
  },
  GET_FEEDBACK_CHAT_LIST: (state, payload) => {
    let feedbackChatList = payload;
    state.feedbackChatList = feedbackChatList
  },
  GET_FEEDBACK_DETAIL_HISTORY_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let feedbackDetailHistory = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;
      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.feedbackDetailHistory = {results: feedbackDetailHistory, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.feedbackDetailHistory = payload;
    }
  },
  // =======================================
  // Department
  // =======================================
  GET_DEPARTMENT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let departmentList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.departmentList = {results: departmentList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.departmentList = payload;
    }
  },
  GET_DEPARTMENT_LIST_NO_PAGE: (state, payload) => {
    let departmentListNoPage = payload;
    state.departmentListNoPage = departmentListNoPage
  },
  // =======================================
  // Subject in department
  // =======================================
  GET_FEEDBACK_SUBJECT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let subjectList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.subjectInDepartment = {results: subjectList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.subjectInDepartment = payload;
    }
  },
  // =======================================
  // Get enable module and extra info
  // =======================================
  GET_ENABLE_MODULE_AND_EXTRA_INFO: (state, payload) => {
    state.enableModuleAndExtraInfo = payload
  },
  // =======================================
  // Apartment Type
  // =======================================
  GET_APARTMENT_TYPE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentTypeList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentTypeList = {results: apartmentTypeList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentTypeList = payload;
    }
  },
  GET_APARTMENT_TYPE_LIST_NO_PAGE: (state, payload) => {
    state.apartmentTypeListNoPage = payload
  },
  // =======================================
  // Apartment Group
  // =======================================
  GET_APARTMENT_GROUP_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentGroupList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentGroupList = {results: apartmentGroupList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentGroupList = payload;
    }
  },
  // =======================================
  // Apartment Image
  // =======================================
  GET_APARTMENT_IMG_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentImgList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentImgList = {results: apartmentImgList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentImgList = payload;
    }
  },
  GET_APARTMENT_MAP_IMG_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentMapImgList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentMapImgList = {results: apartmentMapImgList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentMapImgList = payload;
    }
  },
  GET_APARTMENT_CONTRACT_IMG_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentContractImgList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentContractImgList = {results: apartmentContractImgList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentContractImgList = payload;
    }
  },
  // =======================================
  // Product Unit
  // =======================================
  GET_PRODUCT_UNIT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let productUnit = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.productUnit = {results: productUnit, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.productUnit = payload;
    }
  },
  GET_PRODUCT_UNIT_LIST_NO_PAGE: (state, payload) => {
    state.productUnitNoPage = payload;
  },
  // =======================================
  // Product Group
  // =======================================
  GET_PRODUCT_GROUP_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let productGroup = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.productGroup = {results: productGroup, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.productGroup = payload;
    }
  },
  GET_PRODUCT_GROUP_LIST_NO_PAGE: (state, payload) => {
    state.productGroupNoPage = payload;
  },
  // =======================================
  // Product
  // =======================================
  GET_PRODUCT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let productList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.productList = {results: productList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.productList = payload;
    }
  },
  GET_PRODUCT_LIST_NO_PAGE: (state, payload) => {
    state.productListNoPage = payload
  },
  // =======================================
  // Service
  // =======================================
  GET_SERVICE_LIST_V2: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let serviceList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.serviceList = {results: serviceList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.serviceList = payload;
    }
  },
  GET_SERVICE_LIST_V2_NO_PAGE: (state, payload) => {
    state.serviceListNoPage = payload;
  },
  GET_SERVICE_HISTORY: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let serviceHistoryList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.serviceHistoryList = {results: serviceHistoryList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.serviceHistoryList = payload;
    }
  },
  // =======================================
  // Service group
  // =======================================
  GET_SERVICE_GROUP_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let serviceGroup = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.serviceGroup = {results: serviceGroup, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.serviceGroup = payload;
    }
  },
  GET_SERVICE_GROUP_LIST_NO_PAGE: (state, payload) => {
    state.serviceGroupNoPage = payload;
  },
  // =======================================
  // Service unit
  // =======================================
  GET_SERVICE_UNIT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let serviceUnit = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.serviceUnit = {results: serviceUnit, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.serviceUnit = payload;
    }
  },
  GET_SERVICE_UNIT_LIST_NO_PAGE: (state, payload) => {
    state.serviceUnitNoPage = payload;
  },
  // =======================================
  // Service attribute
  // =======================================
  GET_SERVICE_ATTRIBUTE_LIST: (state, payload) => {
    state.serviceAttributeList = payload;
  },
  // =======================================
  // Product in apartment
  // =======================================
  GET_PRODUCT_IN_APARTMENT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let productInApartment = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.productInApartment = {results: productInApartment, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.productInApartment = payload;
    }
  },
  // =======================================
  // Service in apartment
  // =======================================
  GET_SERVICE_IN_APARTMENT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let serviceInApartment = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.serviceInApartment = {results: serviceInApartment, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.serviceInApartment = payload;
    }
  },
  // =======================================
  // Apartment in group
  // =======================================
  GET_APARTMENT_IN_GROUP_LIST: (state, payload) => {
    state.apartmentInGroup = payload;
  },
  GET_APARTMENT_IN_GROUP_WITH_GROUP_ID_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentInGroupWithId = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentInGroupWithId = {results: apartmentInGroupWithId, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentInGroupWithId = payload;
    }
  },
  // =======================================
  // Apartment booking
  // =======================================
  GET_APARTMENT_BOOKING_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentBookingList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentBookingList = {results: apartmentBookingList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentBookingList = payload;
    }
  },
  GET_APARTMENT_BOOKING_DETAIL: (state, payload) => {
    state.apartmentBookingDetail = payload;
  },
  GET_APARTMENT_BOOKING_LIST_FOR_TIME_LINE: (state, payload) => {
    state.apartmentBookingListForTimeLine = payload;
  },
  GET_APARTMENT_LIST_IN_BOOKING: (state, payload) => {
    state.apartmentListInBooking = payload;
  },
  GET_USER_LIST_IN_BOOKING: (state, payload) => {
    state.userListInBooking = payload;
  },
  GET_USER_BOOKING_IN_APARTMENT: (state, payload) => {
    state.userBookingInApartment = payload;
  },
  // =======================================
  // Apartment type price
  // =======================================
  GET_APARTMENT_TYPE_PRICE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let apartmentTypePriceList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.apartmentTypePriceList = {results: apartmentTypePriceList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.apartmentTypePriceList = payload;
    }
  },
  // =======================================
  // Project extra info
  // =======================================
  GET_PROJECT_EXTRA_INFO: (state, payload) => {
    state.projectExtraInfo = payload;
  },
  // =======================================
  // Product in apartment type
  // =======================================
  GET_PRODUCT_IN_APARTMENT_TYPE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let productInApartmentType = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.productInApartmentType = {results: productInApartmentType, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.productInApartmentType = payload;
    }
  },
  GET_PRODUCT_IN_APARTMENT_TYPE_LIST_NO_PAGE: (state, payload) => {
    state.productInApartmentTypeNoPage = payload;
  },
  // =======================================
  // Product and service used in apartment in booking
  // =======================================
  GET_PRODUCT_AND_SERVICE_USED_IN_APARTMENT_IN_BOOKING: (state, payload) => {
    state.productAndServiceUsedInApartmentInBooking = payload;
  },
  // =======================================
  // Service package
  // =======================================
  GET_SERVICE_PACKAGE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let servicePackageList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.servicePackageList = {results: servicePackageList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.servicePackageList = payload;
    }
  },
  GET_SERVICE_LIST_ENABLE: (state, payload) => {
    state.serviceListEnable = payload;
  },
  // =======================================
  // Management Service order
  // =======================================
  GET_NUMBER_SERVICE_ORDER_LIST: (state, payload) => {
    state.numberServiceOrderList = payload;
  },
  GET_SERVICE_ORDER_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let servicerOrderList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.servicerOrderList = {results: servicerOrderList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.servicerOrderList = payload;
    }
  },
  GET_SERVICE_ORDER_DETAIL: (state, payload) => {
    state.servicerOrderDetail = payload;
  },
  // =======================================
  // Apartment receipt
  // =======================================
  GET_APARTMENT_RECEIPT_INVOICE_REVENUE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let invoiceRevenueList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.invoiceRevenueList = {results: invoiceRevenueList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.invoiceRevenueList = payload;
    }
  },
  // =======================================
  // Room Performance Report
  // =======================================
  GET_ROOM_PERFORMANCE_REPORT: (state, payload) => {
    state.roomPerformanceReportList = payload;
  },
  // =======================================
  // Position
  // =======================================
  GET_POSITION_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let positionList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.positionList = {results: positionList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.positionList = payload;
    }
  },
  // =======================================
  // User extra info
  // =======================================
  GET_USER_EXTRA_INFO: (state, payload) => {
    state.userExtraInfo = payload;
  },
  // =======================================
  // Event management
  // =======================================
  GET_EVENT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let eventList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.eventList = {results: eventList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.eventList = payload;
    }
  },
  // =======================================
  // Config Email Group
  // =======================================
  GET_CONFIG_EMAIL_GROUP: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let configEmailGroupList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.configEmailGroupList = {results: configEmailGroupList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.configEmailGroupList = payload;
    }
  },
  // =======================================
  // Config Revenue Code
  // =======================================
  GET_CONFIG_REVENUE_CODE: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let configRevenueCodeList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.configRevenueCodeList = {results: configRevenueCodeList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.configRevenueCodeList = payload;
    }
  },
  GET_MAINTENANCE_TYPE_LIST: (state, payload) => {
    state.maintenanceTypeList = payload;
  },
  // =======================================
  // Maintenances
  // =======================================
  GET_MAINTENANCE_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let maintenanceList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.maintenanceList = {results: maintenanceList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.maintenanceList = payload;
    }
  },
  GET_MAINTENANCE_LIST_NO_PAGE: (state, payload) => {
    let maintenanceListNoPage = payload;
    state.maintenanceListNoPage = maintenanceListNoPage;
  },
  GET_MAINTENANCE_DETAIL: (state, payload) => {
    state.maintenanceDetail = payload;
  },
  GET_ASSET_DETAIL_MAINTENANCE_HISTORY_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let assetMaintenanceHistoryList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.assetMaintenanceHistoryList = {results: assetMaintenanceHistoryList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.assetMaintenanceHistoryList = payload;
    }
  },
  GET_MAINTENANCE_HISTORY_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let maintenanceHistoryList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.maintenanceHistoryList = {results: maintenanceHistoryList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.maintenanceHistoryList = payload;
    }
  },
  GET_ACTIVITY_TRACKING_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let activityTrackingList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.activityTrackingList = {results: activityTrackingList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.activityTrackingList = payload;
    }
  },
  GET_ACTIVITY_PLAN_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let activityPlanList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.activityPlanList = {results: activityPlanList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.activityPlanList = payload;
    }
  },
  // =======================================
  // External Link
  // =======================================
  GET_EXTERNAL_LINK_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let externalLinkList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.externalLinkList = {results: externalLinkList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.externalLinkList = payload;
    }
  },
  // =======================================
  // Frequently Asked Questions
  // =======================================
  GET_FREQUENTLY_ASKED_QUESTIONS_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let frequentlyAskedQuestions = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.frequentlyAskedQuestions = {results: frequentlyAskedQuestions, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.frequentlyAskedQuestions = payload;
    }
  },
  // =======================================
  // Incident
  // =======================================
  GET_INCIDENT_IN_FEEDBACK_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let incidentInFeedbackList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.incidentInFeedbackList = {results: incidentInFeedbackList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.incidentInFeedbackList = payload;
    }
  },
  // =======================================
  // Asset Supplier
  // =======================================
  GET_ASSET_SUPPLIER_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let assetSupplierList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.assetSupplierList = {results: assetSupplierList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.assetSupplierList = payload;
    }
  },
  GET_ASSET_SUPPLIER_LIST_NO_PAGE: (state, payload) => {
    let assetSupplierListNoPage = payload;
    state.assetSupplierListNoPage = assetSupplierListNoPage;
  },
  // =======================================
  // Approval Apartment Resident
  // =======================================
  GET_APPROVAL_APARTMENT_RESIDENT_LIST: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let approvalApartmentResidentList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.approvalApartmentResidentList = {results: approvalApartmentResidentList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.approvalApartmentResidentList = payload;
    }
  },
  GET_NUMBER_APPROVAL_APARTMENT_RESIDENT: (state, payload) => {
    let numberApprovalApartmentResident = payload;
    state.numberApprovalApartmentResident = numberApprovalApartmentResident;
  },
  GET_INVOICE_HISTORY: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let invoiceHistoryList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.invoiceHistoryList = {results: invoiceHistoryList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.invoiceHistoryList = payload;
    }
  },
  GET_NOTIFICATION: (state, payload) => {
    if (typeof payload.results !== "undefined") {
      let notificationList = payload.results;
      state.pagination.total = payload.count;
      state.pagination.page = isNaN(payload.page) ? 1 : payload.page;
      state.pageArrow.prev = payload.previous;
      state.pageArrow.next = payload.next;

      let page = {
        totalItem: payload.count,
        currentPage: isNaN(payload.page) ? 1 : payload.page,
        pageSize: payload.page_size,
        numPages: payload.num_pages
      }
      state.notificationList = {results: notificationList, paginate: page};
      setPaginator(state, state.pagination);
    } else {
      state.notificationList = payload;
    }
  },
};

function setPaginator(state, pages) {
  let targetPage = pages.page;
  let isBeforeJump = false;
  let isAfterJump = false;

  const minPage = 1;
  const maxPage = Math.floor((pages.total - 1) / pages.size) + 1;

  if (targetPage > maxPage) {
    targetPage = maxPage;
  }
  if (targetPage < 1) {
    targetPage = 1;
  }
  let drawMin = minPage;
  let drawMax = maxPage;
  if (
    targetPage - PAGINATIION_DRAW < minPage &&
    targetPage + PAGINATIION_DRAW > maxPage
  ) {
    drawMin = minPage;
    drawMax = maxPage;
  } else if (
    targetPage - PAGINATIION_DRAW < minPage &&
    !(targetPage + PAGINATIION_DRAW > maxPage)
  ) {
    drawMin = minPage;
    drawMax =
      drawMin + PAGINATIION_DRAW * 2 > maxPage
        ? maxPage
        : drawMin + PAGINATIION_DRAW * 2;
  } else if (
    !(targetPage - PAGINATIION_DRAW < minPage) &&
    targetPage + PAGINATIION_DRAW > maxPage
  ) {
    drawMax = maxPage;
    drawMin =
      drawMax - PAGINATIION_DRAW * 2 < minPage
        ? minPage
        : drawMax - PAGINATIION_DRAW * 2;
  } else {
    drawMin = targetPage - PAGINATIION_DRAW;
    drawMax = targetPage + PAGINATIION_DRAW;
  }

  isBeforeJump = !(drawMin === minPage);
  isAfterJump = !(drawMax === maxPage);

  state.paginator = [];

  if (isBeforeJump) {
    state.paginator.push({
      number: true,
      target: false,
      value: minPage,
      text: minPage
    });
    if (drawMin - 1 !== minPage) {
      state.paginator.push({
        number: false,
        target: false,
        value: 0,
        text: "..."
      });
    }
  }

  for (let i = drawMin; i <= drawMax; i++) {
    state.paginator.push({
      number: true,
      target: i === targetPage,
      value: i,
      text: i
    });
  }

  if (isAfterJump) {
    if (drawMax + 1 !== maxPage) {
      state.paginator.push({
        number: false,
        target: false,
        value: 0,
        text: "..."
      });
    }
    state.paginator.push({
      number: true,
      target: false,
      value: maxPage,
      text: maxPage
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js